import { render } from "./VsTr.vue?vue&type=template&id=2d2b4242"
import script from "./VsTr.vue?vue&type=script&lang=js"
export * from "./VsTr.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__